import {Cards} from '/constant/TestIDs';
import {BUSINESS_COACH, BUSINESS_LEADER} from '/enum/competency.enum';

export type Competency = typeof BUSINESS_COACH | typeof BUSINESS_LEADER;

export type TeamSummaryKeys = {
  lastKey: string;
  lastLabel: string;
  newKey: string;
  newLabel: string;
  newTestID: string;
  newTitleTestID: string;
  projectedKey: string;
  projectedLabel: string;
  projectedTestID: string;
  projectedTitleTestID: string;
  totalKey: string;
  totalLabel: string;
  totalTestID: string;
  totalTitleTestID: string;
  projectedTotalKey: string;
  projectedTotalLabel: string;
  projectedTotalTestID: string;
  projectedTotalTitleTestID: string;
};

const BASE_KEYS = {
  lastKey: 'total.last',
  lastLabel: 'Same Day Last Month',
};

const TEAM_SUMMARY_CONFIG: Record<
  string,
  Omit<TeamSummaryKeys, keyof typeof BASE_KEYS>
> = {
  [BUSINESS_COACH]: {
    newKey: 'new.frontline',
    newLabel: 'Frontline Qualifying Volume',
    newTestID: Cards.cardFrontlineQualifyingVolumeValue,
    newTitleTestID: Cards.cardFrontlineQualifyingVolumeTitle,
    projectedKey: 'projected.fqv',
    projectedLabel: 'Projected FQV',
    projectedTestID: Cards.cardProjectedFQVValue,
    projectedTitleTestID: Cards.cardProjectedFQVTitle,
    totalKey: 'total.gen0',
    totalLabel: 'Total Gen0 Volume',
    totalTestID: Cards.cardTotalGen0VolumeValue,
    totalTitleTestID: Cards.cardTotalGen0VolumeTitle,
    projectedTotalKey: 'projected.gen0',
    projectedTotalLabel: 'Projected Gen0 Volume',
    projectedTotalTestID: Cards.cardProjectedGen0VolumeValue,
    projectedTotalTitleTestID: Cards.cardProjectedGen0VolumeTitle,
  },

  [BUSINESS_LEADER]: {
    newKey: 'new.generation',
    newLabel: 'Generation 0 Volume',
    newTestID: Cards.cardGeneration0VolumeValue,
    newTitleTestID: Cards.cardGeneration0VolumeTitle,
    projectedKey: 'projected.gen0',
    projectedLabel: 'Projected Gen0 Volume',
    projectedTestID: Cards.cardProjectedGen0VolumeValue,
    projectedTitleTestID: Cards.cardProjectedGen0VolumeTitle,
    totalKey: 'total.generation',
    totalLabel: 'Total Generation Volume',
    totalTestID: Cards.cardTotalGenerationVolumeValue,
    totalTitleTestID: Cards.cardTotalGenerationVolumeTitle,
    projectedTotalKey: 'projected.TGenV',
    projectedTotalLabel: 'Projected TGenV',
    projectedTotalTestID: Cards.cardProjectedTGenVolumeValue,
    projectedTotalTitleTestID: Cards.cardProjectedTGenVolumeTitle,
  },
};

export function getTeamSummaryKeys(
  currentUserCompetency: Competency,
): TeamSummaryKeys {
  const config = TEAM_SUMMARY_CONFIG[currentUserCompetency];

  if (!config) {
    throw new Error(`Unsupported competency: ${currentUserCompetency}`);
  }

  return {
    ...BASE_KEYS,
    ...config,
  };
}

export const sdlmTransformer = (val: any) => {
  if (isNaN(val)) {
    return 0;
  } else {
    return val;
  }
};
